(() => {
  const script = document.getElementById('wbo-configuration-accessibility');
  if (!script) return;
  const strings = script.dataset;
  let nextId = 0;
  const invalidBefore = new WeakMap();
  const liveRegions = new WeakMap();
  const identified = (element) => {
    if (!element.id) element.id = `wbo-config-a11y-${++nextId}`;
    return element.id;
  };
  const appendReference = (element, attribute, id) => {
    const values = new Set((element.getAttribute(attribute) || '').split(/\s+/).filter(Boolean));
    values.add(id);
    element.setAttribute(attribute, [...values].join(' '));
  };
  const enhance = (root) => {
    const messages = [];
    root.querySelectorAll('.optionHolder').forEach((holder) => {
      const heading = holder.querySelector('.option-label');
      if (!heading) return;
      const title = heading.textContent.trim();
      const required = /\*\s*$/.test(title);
      const controls = [...holder.querySelectorAll('input:not([type="button"]):not([type="hidden"]), select, textarea')];
      const radioGroup = holder.querySelector('.option-type-swatch, .option-type-radio');
      if (radioGroup && radioGroup.querySelector('input[type="radio"]')) {
        radioGroup.setAttribute('role', 'radiogroup');
        radioGroup.setAttribute('aria-labelledby', identified(heading));
        if (required) radioGroup.setAttribute('aria-required', 'true');
      }
      controls.forEach((control) => {
        if (control.type === 'radio') {
          const visibleName = control.closest('.swatch-title-holder')?.querySelector('.swatch-title-text');
          if (visibleName?.textContent.trim()) control.setAttribute('aria-labelledby', identified(visibleName));
        } else {
          const dimension = control.closest('.inputHolder')?.querySelector('.option-label');
          if (dimension) {
            const suffix = control.tagName === 'SELECT' ? strings.fractionInches : strings.wholeInches;
            control.setAttribute('aria-label', `${dimension.textContent.trim()} (${suffix})`);
          } else if (!control.getAttribute('aria-label') && !control.getAttribute('aria-labelledby')) {
            control.setAttribute('aria-labelledby', identified(heading));
          }
          if (required) control.setAttribute('aria-required', 'true');
        }
        holder.querySelectorAll('.helpText').forEach((help) => {
          if (help.textContent.trim()) appendReference(control, 'aria-describedby', identified(help));
        });
      });
      const invalid = new Set();
      holder.querySelectorAll('.errorMsgCss').forEach((error) => {
        const errorId = identified(error);
        const local = error.closest('.inputHolder');
        const targets = local ? controls.filter((control) => local.contains(control)) : controls;
        targets.forEach((control) => appendReference(control, 'aria-describedby', errorId));
        if (error.textContent.trim() && !error.hidden && getComputedStyle(error).display !== 'none') {
          messages.push(error.textContent.trim());
          targets.forEach((control) => invalid.add(control));
        }
      });
      controls.forEach((control) => {
        if (invalid.has(control)) {
          if (!invalidBefore.has(control)) invalidBefore.set(control, control.getAttribute('aria-invalid'));
          control.setAttribute('aria-invalid', 'true');
        } else if (invalidBefore.has(control)) {
          const previous = invalidBefore.get(control);
          if (previous === null) control.removeAttribute('aria-invalid');
          else control.setAttribute('aria-invalid', previous);
          invalidBefore.delete(control);
        }
      });
      holder.querySelectorAll('.minus1, .add1').forEach((button) => {
        button.setAttribute('aria-label', button.classList.contains('minus1') ? strings.decrease : strings.increase);
      });
    });
    let live = liveRegions.get(root);
    if (!live) {
      live = document.createElement('div');
      live.className = 'wbo-configuration-errors';
      live.setAttribute('role', 'alert');
      live.setAttribute('aria-atomic', 'true');
      root.appendChild(live);
      liveRegions.set(root, live);
    }
    const announcement = [...new Set(messages)].join('. ');
    if (live.textContent !== announcement) live.textContent = announcement;
  };
  const observed = new WeakSet();
  const discover = () => {
    document.querySelectorAll('product-options-section').forEach((root) => {
      if (observed.has(root)) return;
      observed.add(root);
      enhance(root);
      let queued = false;
      new MutationObserver(() => {
        if (queued) return;
        queued = true;
        queueMicrotask(() => {
          queued = false;
          enhance(root);
        });
      }).observe(root, { childList: true, subtree: true, characterData: true });
    });
  };
  discover();
  new MutationObserver(discover).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
})();
